const routes = [
  {
    path: "/",
    component: () => import("@/pages/Layout/DashboardLayout.vue"),
    redirect: "/dashboard",
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        component: () => import("@/pages/Dashboard.vue")
      },
      {
        path: "applications",
        name: "Applications",
        component: () => import("@/pages/Applications.vue")
      },
      {
        path: "applications/:applicantId",
        name: "Applicant Information",
        component: () => import("@/pages/ApplicantInformation.vue"),
        props: true
      },
      {
        path: "user",
        name: "User Profile",
        component: () => import("@/pages/UserProfile.vue")
      }
    ]
  }
];

export default routes;
